import { DataTableActionsComponent, dataTableActionsTemplate } from './DataTableActions';
import styles from './DataTableActions.styles.scss';
export const chameleonDataTableActions = DataTableActionsComponent.compose({
    baseName: 'data-table-actions',
    template: dataTableActionsTemplate,
    styles,
});
